import { useSelector } from 'react-redux';
import { ApplicationState } from '@/store';
import { IUniId } from 'types';

export function useProviderUniversities(): { universities: IUniId[] } {
  const relatedUnis = useSelector(({ config }: ApplicationState) => config.relatedUnis || []);
  const universityIds = useSelector(({ apply }: ApplicationState) => apply.universityIds || []);

  const matchedUnis = universityIds.filter(uniId => relatedUnis.includes(uniId.value));

  return { universities: matchedUnis };
}
